import styled from '../../shared/Styles/styled-components';

export const Icon = styled.img`
  height: 44px;
`;

export default Icon;
